import React from "react";
import { Title } from "../../../../../stories/Title/Title";
import InputHoc from "../../../../common/Input/Index";
import { Keys } from "../../../../../utils/Enum.keys";
import { AddMasterDataProps } from "./index";

const Add = ({ formData, handleValueChange, meta }: AddMasterDataProps) => {
  const saveButton = document.getElementsByClassName("sub");

  const emailConfigInputField = [
    {
      labelName: "From",
      inputName: "from",
      dataType: "text",
      autoFocus: true,
      required: true,
    },
    {
      labelName: "Password",
      inputName: "password",
      dataType: "text",
      required: true,
    },
    {
      labelName: "Smtp Host",
      inputName: "smtpHost",
      dataType: "text",
      required: true,
    },
    {
      labelName: "Smtp Port",
      inputName: "smtpPort",
      dataType: "text",
      required: true,
    },
  ];

  return (
    <>
      <div className="master-data__add">
        <Title variant="subtitle1">Add Email Config</Title>
        <div className="master-data__add--form">
          {emailConfigInputField.map((field) => {
            return (
              <InputHoc
                LabelName={field.labelName}
                values={formData[field.inputName]}
                name={field.inputName}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleValueChange(e, meta)
                }
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                  if (e.key === Keys.ENTER) {
                    if (saveButton.length) {
                      (saveButton[0] as HTMLButtonElement).focus();
                    }
                  }
                }}
                autoFocus={field.autoFocus}
                required
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Add;
